import { render, staticRenderFns } from "./ReceptionPermissionVoirieAcces.vue?vue&type=template&id=e630dda2"
import script from "./ReceptionPermissionVoirieAcces.vue?vue&type=script&lang=js"
export * from "./ReceptionPermissionVoirieAcces.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports